<script setup lang="ts">
/** The bordered surface shell for a stat tile, list card or form panel. */
const props = withDefaults(defineProps<{ padding?: 'none' | 'cell' | 'group' | 'block' }>(), {
  padding: 'group',
})

const PADDING = {
  none: '',
  cell: 'p-[var(--space-cell)]',
  group: 'p-[var(--space-group)]',
  block: 'p-[var(--space-block)]',
} as const
</script>

<template>
  <div
    class="rounded-[var(--radius-surface)] border border-[color:var(--color-border)] bg-[color:var(--color-surface)]"
    :class="PADDING[props.padding]"
  >
    <slot />
  </div>
</template>
